import { ICliJob } from 'cli/types';
import { mapRecordFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { getQueryStringToSnakeCase, objectKeysSnakeCaseToCamelCase } from 'core/utils';

export const getDetails = async (params, signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get(
    `/cli/job/details?${getQueryStringToSnakeCase(params)}`,
    signal
  );

  const job = {
    ...data.job,
    result: objectKeysSnakeCaseToCamelCase(JSON.parse((data.job.result as string) || '{}')),
  };

  return mapRecordFromServer<ICliJob>(job, data.success);
};
